import Layout2 from '@/layout/Layout2'
let ja = require('../../common/lang/ja')
let zh = require('../../common/lang/zh-CN')

export default [{
  path: '/role',
  component: Layout2,
  children: [{
    path: '',
    name: 'role',
    component: () => import('@/merchanAdmin/role/RoleList'),
    meta: {
      zhtitle: zh.m.aside.nav.ROLE,
      jatitle: ja.m.aside.nav.ROLE,
      pername: "admin_roleSetting"
    },
  }, {
    path: '/roleDetail',
    name: 'roleDetail',
    component: () => import('@/merchanAdmin/role/RoleDetail'),
    meta: {
      zhtitle: zh.m.router.common.CREATE,
      jatitle: ja.m.router.common.CREATE,
      pername: "admin_roleSetting"
    },
  }, {
    path: '/meDetail',
    name: 'meDetail',
    component: () => import('@/merchanAdmin/role/meDetail'),
    meta: {
      zhtitle: zh.m.content.pushes.PERSON_INFORMATION,
      jatitle: ja.m.content.pushes.PERSON_INFORMATION,
      pername: "admin_roleSetting"
    },
  }
  ]
}]
